/*
 * @Author: Lius 
 * @Date: 2021-11-08 13:58:26 
 * @Last Modified by: Lius
 * @Last Modified time: 2021-11-30 17:29:07
 */

import { get, post, put } from "@/static/req/http"


import http from "@/http"


//   获取首页信息
export function getindex(){
    return post('home/pagehome/index')
}

//   获取新品信息
export function indexHot(data){
    return post(`home/pagehome/indexHot?page=${data.page}&limit=${data.limit}`)
}

//   获取特价信息
export function indexCount(data){
    return post(`home/pagehome/indexCount?page=${data.page}&limit=${data.limit}`)
}


//   获取商品分类信息
export function getgoodstype(){
    return post('home/pagehome/goodstype')
}


//   获取关于我们信息
export function getabout(){
    return post('home/pagehome/contact')
} 

//   获取x项目介绍信息
export function getintro(){
    return post('home/pagehome/intro')
}

//   获取视频信息
export function getvideo(){
    return get('wapapi/index/video')
}

//   获取新闻列表
export function getnews(data){
    return get(`wapapi/index/notice?page=${data.page}&limit=${data.limit}`)
}

//   获取产品详情
export function getproductview(id){
    return post(`home/pagehome/goodsdetail?id=${id}`)
}


//   获取二级页面商品列表
export function getbrand(data){
    return post(`home/pagehome/brand`,data)
}


//  联系我们
export function getconcact(){
    return post('home/pagehome/cont')
}


//  我们服务
export function getservice(){
    return post('home/pagehome/shopsList')
}

// //  二级页面
// export function getgoodstype(){
//     return post('home/pagehome/goodstype')
// }

//  联系我们
export function getmessages(data){
    return post('home/pagehome/messages',data)
}

//  获取科室
export function getdoctor(data){
    return post(`wapapi/index/get_doctor?page=${data.page}&limit=${data.limit}`)
}

//  获取医生file
export function get_doctor_ifi(data){
    return post(`wapapi/index/get_doctor_ifi`)
}


//  购物车提交订单
export function cartadd(data){
    return post('home/pagehome/add',data)
}

//  库存查询
export function seach_num(data){
    return post('home/pagehome/seach_num',data)
}
//  登录提交
export function getlogin(data){
    return post('home/slogin/slogin',data)
}
 

//** 帮助手册 */
///dev-api/api/helpManual/category/list
//获取帮助手册种类
export function getHelpManualCategoryList(){
    return get('/api/helpManual/category/list')
}

// /dev-api/api/helpManual/content/list/{categoryId}
//分页查询指定种类的帮助列表
export function getHelpManualContentList(categoryId){
    return get(`/api/helpManual/content/list/${categoryId}`)
}

// /dev-api/api/helpManual/updateViewCount/{id} 更新帮助手册查看数量
export function updateViewCount(data){
    return put(`/api/helpManual/updateViewCount/${data.id}`,data)
}


// export function updateViewCount(data){
//     return http({
//         URL: `/api/helpManual/updateViewCount/${data.id}`,
//         method: 'put',
//     })
// }



// WEBPACK FOOTER //
// ./src/api/index/index.js